// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import fr from 'vee-validate/dist/locale/fr'
import VeeValidate, { Validator } from 'vee-validate'
import Notifications from 'vue-notification'
import vueMoment from 'vue-moment'
import moment from 'moment'
require('moment/locale/fr')
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import VueAnalytics from 'vue-analytics'
import 'es6-promise/auto'
import JQuery from 'jquery'

import App from './App'
import store from './store'
import router from './router'
import inputUI from './common/directives/inputUI'
import selectUI from './common/directives/selectUI'
import baseModal from './common/components/baseModal'
import agTable from './common/components/ag-table'
import toggleInput from './common/components/toggle-input'
import radioBox from './common/components/Form/RadioBox'
import { VueRobot } from './common/services/iRobot'
import ImageDetect from './common/directives/ImageDetect'

// Style for Ag-Grid
import '../node_modules/ag-grid/dist/styles/ag-grid.css'
import '../node_modules/ag-grid/dist/styles/ag-theme-balham.css'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

import VueSweetalert2 from 'vue-sweetalert2'

window.$ = JQuery
window.jQuery = JQuery

if (['production', 'staging'].includes(process.env.NODE_ENV)) {
	Sentry.init({
		dsn: 'https://3e55c20d3c254b9c833d7d23cf1d98f5@sentry.io/1846664',
		environment: process.env.NODE_ENV,
		integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })]
	})
}

Vue.use(inputUI)
Vue.use(selectUI)
Validator.localize('fr', fr)
Vue.use(VeeValidate)
Vue.use(Notifications)
Vue.use(vueMoment, { moment })
Vue.component('v-select', vSelect)
Vue.component('base-modal', baseModal)
Vue.component('ag-table', agTable)
Vue.component('multiselect', Multiselect)
Vue.component('toggle-input', toggleInput)
Vue.component('radio-box', radioBox)
Vue.use(VueRobot)
Vue.use(ImageDetect)
Vue.use(VueAnalytics, {
	id: 'UA-109825003-3',
	autoTracking: {
		screenview: true
	}
})
Vue.use(VueSweetalert2)

require('./common/services/ExtendRules')

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	template: '<App/>',
	components: {
		App,
		baseModal,
		vSelect,
		Multiselect
	},
	created: function () {
		window.Vue = this
	},
	store,
	router
})



// WEBPACK FOOTER //
// ./src/main.js